type GenericObject = {
  [key: string]: any;
};

export function removeEmptyKeys(object: GenericObject): GenericObject {
  return Object.entries(object)
    .filter(([_key, value]) => value)
    .reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value === Object(value) ? removeEmptyKeys(value) : value,
      }),
      {}
    );
}
